import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Tooltip,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export default function SavedSignatures({ signatures, onSelect, onDelete }) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (signatures.length === 0) return null;

  const displaySignatures = isExpanded ? signatures : signatures.slice(0, 3);

  return (
    <Box mt={4} pt={2} borderTop="1px solid #e0e0e0">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="subtitle1" color="text.secondary">
          Saved Signatures
        </Typography>
        {signatures.length > 3 && (
          <Button variant="text" size="small" onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? 'Show less' : `Show all (${signatures.length})`}
          </Button>
        )}
      </Box>

      <Grid container spacing={2}>
        {displaySignatures.map((signature) => (
          <Grid item xs={12} sm={6} md={4} key={signature.id}>
            <Card
              variant="outlined"
              sx={{
                cursor: 'pointer',
                position: 'relative',
                transition: '0.2s',
                '&:hover': {
                  backgroundColor: 'grey.100',
                },
              }}
              onClick={() => onSelect(signature.data)}
            >
              <CardContent sx={{ textAlign: 'center', height: 100, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CardMedia
                  component="img"
                  src={signature.data}
                  alt={signature.name}
                  sx={{ maxHeight: 64, objectFit: 'contain' }}
                />
              </CardContent>

              <Box px={2} pb={2} display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="caption" noWrap title={signature.name} color="text.secondary">
                  {signature.name}
                </Typography>
                <Tooltip title="Delete signature">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(signature.id, e);
                    }}
                    sx={{
                      color: 'error.main',
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Typography variant="caption" color="text.secondary" mt={2} display="block">
        Click on a signature to select it for use.
      </Typography>
    </Box>
  );
}